import React, { useState } from 'react'

import ReportHistoryContentItem from './reportHistoryContentItem'
import HistoryReportItemWrapper from './historyReportItemWrapper'

const HistoryReportItem = props => {
  const { data, isReportSelected, setReportSelected, deleteReport } = props
  const [isSelected, setSelected] = useState(false)
  const setHistoryReport = () => {
    setSelected(true)
    setReportSelected()
  }

  return (
    !isSelected
      ? <ReportHistoryContentItem
        data={data}
        clickItem={!isReportSelected ? setHistoryReport.bind(this) : null}
        deleteReport={deleteReport}
      />
      : <HistoryReportItemWrapper data={data}>
        <ReportHistoryContentItem
          data={data}
        />
      </HistoryReportItemWrapper>
  )
}

export default React.memo(HistoryReportItem)